import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAgencyInfo, getSessionValue, parseJSON, setSessionValue, updateAgencyInfo } from '../Common/Appcommon';

export const AppContext = createContext();

let globalTheme = getSessionValue('theme') || 'light-theme';
let globalColorScheme = getAgencyInfo("Designation") || 'default';

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        // Get the saved theme from localStorage
        return getSessionValue("theme") || 'light-theme';
    });
    const [colorScheme, setColorScheme] = useState(() => {
        // Get the saved theme from localStorage
        return getAgencyInfo("Designation") || 'default';
    });
    const [subCurrency, setSubCurrency] = useState();
    const [subCurrencyISO, setSubCurrencyISO] = useState("");
    const [subCurrencyIcon, setSubCurrencyIcon] = useState("");
    const [agencyCurrency, setAgencyCurrency] = useState();
    const [agencyCurrencyISO, setAgencyCurrencyISO] = useState();

    // notification count
    const [notificationCount, setNotificationCount] = useState(0);

    // notifications enable
    const [showHeaderNoti, setShowHeaderNoti] = useState(null);
    const [showPopupNoti, setShowPopupNoti] = useState(false);
    
    // notifications content
    const [headerNotiContent, setHeaderNotiContent] = useState("");
    const [popupNotiContent, setPopupNotiContent] = useState("");

    //addon min compelte
    const [headerNotiMinutes, setHeaderNotiMinutes] = useState("");

    const [voiceAgList, setVoiceAgList] = useState([]);
    useEffect(() => {
        let a = parseJSON(getSessionValue("aCurrency"));
        let s = parseJSON(getSessionValue("sCurrency"));
        let newData = {};
        newData["agency"] = a;
        newData["subaccount"] = s;
        processCurrency(newData);
    },[])

    const toggleTheme = (newTheme) => {
        //const newTheme = theme === 'light-theme' ? 'dark-theme' : 'light-theme';
        globalTheme = newTheme;
        setTheme(newTheme);
        setSessionValue("theme", newTheme);
    };

    const toggleColorScheme = (newScheme) => {
        //const newTheme = theme === 'light-theme' ? 'dark-theme' : 'light-theme';
        globalColorScheme = newScheme;
        setColorScheme(newScheme);
        updateAgencyInfo(newScheme, "Designation");
    };


    const processCurrency = (currencyList) => {
        if(Object.keys(currencyList).length > 0){
            let acurrency = currencyList["agency"];
            let subaccount = currencyList["subaccount"];
            if(acurrency){
                setAgencyCurrency(acurrency.name ?? "$");
                setAgencyCurrencyISO(acurrency.value ?? "usd");
                setSessionValue("aCurrency", JSON.stringify(acurrency))
            }
            if(subaccount){
                setSubCurrency(subaccount.name ?? "$");
                setSubCurrencyISO(subaccount.value ?? "usd");
                setSubCurrencyIcon(subaccount.icon ?? "");
                setSessionValue("sCurrency", JSON.stringify(subaccount))
            }
        }
    }

    useEffect(() => {
        document.body.className = theme + " " + colorScheme; // Apply theme to body
    }, [theme, colorScheme]);

    return (
        <AppContext.Provider value={{ 
            theme, 
            toggleTheme, 
            processCurrency,
            subCurrency,
            subCurrencyISO,
            agencyCurrency,
            agencyCurrencyISO,
            subCurrencyIcon,
            colorScheme, 
            setColorScheme,
            toggleColorScheme,
            notificationCount,
            setNotificationCount,
            showHeaderNoti,
            showPopupNoti,
            setShowHeaderNoti,
            setShowPopupNoti,
            popupNotiContent,
            headerNotiContent, 
            setHeaderNotiContent,
            setPopupNotiContent,
            headerNotiMinutes,
            setHeaderNotiMinutes,
            voiceAgList,
            setVoiceAgList
        }}>
            <div className={""}>{children}</div>
        </AppContext.Provider>
    );
};

export function getGlobalTheme() {
    return globalTheme;
}
export function getColorScheme() {
    return globalColorScheme;
}
